module.exports = __webpack_public_path__ + "static/media/stockmassIcon.4500bf83.svg";